import React, { useState, useEffect } from "react";
import "./DynamicAlertDialog.css";
import { X } from "react-feather"; // lightweight icon

const DynamicAlertDialog = ({
  title = "Alert",
  message = "",
  type = "info", // success | error | warning | info
  autoShow = false,
}) => {
  const [show, setShow] = useState(autoShow);

  useEffect(() => {
    if (autoShow) setShow(true);
  }, [autoShow]);

  if (!show) return null;

  return (
    <div className="alert-dialog-backdrop" onClick={() => setShow(false)}>
      <div
        className={`alert-dialog alert-${type}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="alert-close-icon"
          onClick={() => setShow(false)}
          aria-label="Close Alert"
        >
          <X size={18} />
        </button>
        <div className="alert-content">
          <h3 className="alert-title">{title}</h3>
          <p className="alert-message">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default DynamicAlertDialog;
